import React from 'react'
import {
    Form,
    Input,
    Radio,
    Space,Upload,Popup,ImagePicker,
    Button, Selector, TextArea, ImageUploader, DatePicker, NavBar, Grid,Image,Avatar,Toast,NumberKeyboard,Mask
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import ImageCropper from './ImageCropper'; // 引入封装的裁剪组件
import {
    UpdateUserInfoByOpenId,SaveNNFile,GetSystemMemorys,SensitiveWordsVerify
} from '../../service/service';
import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import { environment } from '../../service/baseUrl';

import '../UserEdit/index.css'
import { useNavigate } from 'react-router-dom';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        return <WrappedComponent {...props} navigate={navigate} />;
    };
};


class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            fileList: [],
            userInfo: {},
            HeadImg: "",
            visible: "",
            phoneNumber: "",
            openid: "",

            // 裁剪相关状态
            cropVisible: false,
            imageUrl: null, // 原始图片临时 URL
            pendingFile: null, // 待裁剪文件
        };
    }



    // 处理裁剪完成后的上传
    handleCropComplete = async (croppedBlob) => {
        const { pendingFile } = this.state;
        if (!croppedBlob || !pendingFile) return;

        // 转换为File对象（保持原文件名和类型）
        const croppedFile = new File(
            [croppedBlob],
            pendingFile.name,
            { type: pendingFile.type || 'image/jpeg' }
        );

        // 关闭弹窗并上传
        this.setState({ cropVisible: false }, async () => {
            const result = await this.handleUpload(croppedFile);
            this.setState({ fileList: [{ url: result.url, file: croppedFile }] });
        });
    };

    // 上传逻辑
    handleUpload = async (file) => {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('userid', this.state.userInfo.id);
            formData.append('scoureName', 'Img');

            const response = await SaveNNFile(formData);
            if (!response.result) throw new Error('上传失败');

            const imageUrl = `${environment.apiEndpoint}/NNFiles/Img/${response.result}`;
            this.setState({ HeadImg: response.result });
            return { url: imageUrl };
        } catch (error) {
            console.error('上传失败:', error);
            Toast.show({ icon: 'fail', content: '上传失败' });
            throw error;
        }
    };



    componentDidMount() {
        var openid = localStorage.getItem("openid");
        if (openid == null || openid == undefined) {
            Toast.show({
                icon: 'error',
                content: '系统异常，请重新进入！',
            })
            setTimeout(() => {
                window.location.href = environment.wxredirecturi;
            }, 2000);
            return;
        }

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            this.setState({
                openid: openid
            })
            return;
        }
        user = JSON.parse(user);
        var fileList = [];
        if (user.headImg != null && user.headImg != "") {
            fileList.push({
                key: 0,
                url: user.headImg,
                thumbnailUrl: user.headImg,
            })
        }
        this.setState({
            fileList: fileList,
            userInfo: user,
            HeadImg: user.headImg,
            phoneNumber: user.phone == "绑定手机号" ? "" : user.phone,
            openid: openid
        })
        this.formRef.current.setFieldsValue(user)
    }

    handleUpload1 = async (file) => {
        // 创建一个 FormData 对象
        const formData = new FormData();
        formData.append('file', file); // 'file' 是后端接口接收文件的字段名

        try {
            // 发送 POST 请求到后端接口
            const response = await fetch(environment.apiEndpoint + '/api/FileUpload/SaveNNFile', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                Toast.show({
                  icon: 'error',
                  content: '上传失败！',
                })
                return ;
            }

            const result = await response.json();
            this.setState({
                HeadImg: result.result
            })
            // 返回上传成功后的文件 URL
            return {
                url: environment.apiEndpoint + "/NNFiles/Img/" + result.result, // 假设后端返回的文件 URL 字段是 'url'
            };
        } catch (error) {
            console.error('上传失败:', error);
            Toast.show({
              icon: 'error',
              content: '上传失败！',
            })
            return {
                url: URL.createObjectURL(file), // 上传失败时返回本地预览 URL
            };
        }
    };


    submitForm = () => {
        var that = this;
        // 校验表单字段
        this.formRef.current
            .validateFields()
            .then((values) => {
                // 校验通过，获取表单值
                const { Phone } = values;

                // 如果手机号填写了但不符合格式，提示错误
                if (Phone && !/^1[3-9]\d{9}$/.test(Phone)) {
                    Toast.show({
                        icon: 'fail',
                        content: '手机号格式不正确！',
                    });
                    return;
                }

                // 提交表单数据
                const formData = {
                    ...values,
                    HeadImg: this.state.HeadImg, // 添加头像数据
                    OpenId: this.state.openid, // 添加头像数据
                };

                console.log('提交的表单数据:', formData);

                var Contents = [];
                Contents.push(formData.nickName);
                Contents.push(formData.signature);
                var model = {
                    Contents: Contents
                };
                SensitiveWordsVerify(model).then(res => {
                    if (res.result) {
                        UpdateUserInfoByOpenId(formData).then(res => {
                            if (res.success) {
                                if (res.result.headImg != null && res.result.headImg != "") {
                                    if (res.result.headImg.indexOf("https://") > -1) {
                                        var urls = res.result.headImg.split("https://").filter(Boolean);
                                        res.result.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                                    } else {
                                        res.result.headImg = environment.apiEndpoint + "/NNFiles/Img/" + res.result.headImg;
                                    }
                                }
                                localStorage.setItem("user", JSON.stringify(res.result));
                                
                                // 显示成功提示
                                Toast.show({
                                    icon: 'success',
                                    content: '保存成功！',
                                });
        
                                that.props.navigate('/my', { replace: true, state: { from: 'home' } }); // 传递状态
                            } else {
                                Toast.show({
                                    icon: 'fail',
                                    content: '内部异常！',
                                });
                            }
                        })
                    } else {
                        Toast.show({
                            icon: null,
                            content: '表单数据中包含违规内容，请修改后重试！',
                        });
                    }
                })

            })
            .catch((error) => {
                // 校验失败，显示错误提示
                Toast.show({
                    icon: 'fail',
                    content: '请检查表单填写是否正确！',
                });
                console.error('表单校验失败:', error);
            });
    };



    render() {
        const actions = {
            onClose: () => {
                Toast.show('closed');
                this.setState({
                    visible: '',
                });
            },
            onInput: (key) => {
                var value = this.state.phoneNumber + key;
                if (value.length > 11) {
                    Toast.show({ content: '手机号最多11位数！' });
                    return;
                }
                // 更新 phoneNumber 状态
                this.setState(() => ({
                    phoneNumber: value,
                }),
                    () => {
                        // 在状态更新后，同步设置表单字段的值
                        this.formRef.current.setFieldsValue({
                            phone: this.state.phoneNumber,
                        });
                    }
                );
            },
            onDelete: () => {
                // 删除最后一个字符
                this.setState(
                    (prevState) => ({
                        phoneNumber: prevState.phoneNumber.slice(0, -1),
                    }),
                    () => {
                        // 在状态更新后，同步设置表单字段的值
                        this.formRef.current.setFieldsValue({
                            phone: this.state.phoneNumber,
                        });
                    }
                );
            },
        };

        const { fileList, cropVisible, imageUrl } = this.state;

        return (
            <div style={{ width: "100%", height: "100%" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/my', { replace: true, state: { from: 'home' } }); // 传递状态
                }}>
                    编辑资料
                </NavBar>

                <div style={{
                    height: "85%", backgroundColor: "rgb(227 227 227)", paddingTop: "3%"
                }}>

                    <div className="header" style={{ marginTop: "3%", textAlign: "center" }}>
                        




                        {/* 图片上传组件 */}
                        <ImageUploader
                            columns={1}
                            maxCount={1}
                            style={{ '--cell-size': '70px', display: 'inline-block' }}
                            value={fileList || []}
                            beforeUpload={async (file) => {
                                // 文件校验
                                if (!(file instanceof File)) {
                                    Toast.show({ icon: 'fail', content: '无效的文件！' });
                                    return false;
                                }
                                if (file.size > 5 * 1024 * 1024) {
                                    Toast.show({ icon: 'fail', content: '文件大小不能超过5MB！' });
                                    return false;
                                }

                                // 清理旧的临时URL
                                if (this.state.imageUrl) {
                                    URL.revokeObjectURL(this.state.imageUrl);
                                }

                                // 创建新的临时URL并打开裁剪弹窗
                                const tempUrl = URL.createObjectURL(file);
                                this.setState({
                                    imageUrl: tempUrl,
                                    pendingFile: file,
                                    cropVisible: true,
                                });

                                return false; // 阻止默认上传
                            }}
                            onChange={(fileList) => {
                                this.setState({ fileList });
                            }}
                            upload={() => Promise.resolve({ url: '' })}
                            deleteIcon={
                                <img
                                    src="https://api.weibinyi.com/images/niannian/4/40-13.png"
                                    style={{ width: '14px', height: '14px', objectFit: 'fill' }}
                                    alt="删除"
                                />
                            }
                            children={
                                <img
                                    src="https://api.weibinyi.com/images/niannian/4/2-12.png"
                                    style={{ width: '70px', height: '70px', objectFit: 'fill' }}
                                    alt="添加图片"
                                />
                            }
                        />

                        {/* 裁剪弹窗 */}
                        <Popup
                            visible={cropVisible}
                            onClose={() => {
                                if (this.state.imageUrl) {
                                    URL.revokeObjectURL(this.state.imageUrl);
                                }
                                this.setState({
                                    cropVisible: false,
                                    imageUrl: null,
                                    pendingFile: null,
                                });
                            }}
                            bodyStyle={{ padding: 0, height: '85vh' }}
                            maskClosable={true} // 关键：允许点击遮罩层关闭弹窗
                            mask={true} // 确保遮罩层存在（默认数库默认true，但显式声明置更保险）
                        >
                            {imageUrl && <ImageCropper imageUrl={imageUrl}
                                onCropComplete={this.handleCropComplete}
                                handleClose={() => {
                                    this.setState({
                                        cropVisible: false,
                                        imageUrl: null,
                                        pendingFile: null,
                                    });
                                }} />}
                        </Popup>




                        {/* <ImageUploader
                            columns={1}
                            maxCount={1}
                            style={{ '--cell-size': '70px', display: 'inline-block' }}
                            value={this.state.fileList || []}
                            defaultValue={this.state.fileList || []}
                            beforeUpload={async (file) => {
                                console.log('BeforeUpload - 文件信息:', file);
                                if (!(file instanceof File)) {
                                    Toast.show({ icon: 'fail', content: '无效的文件！' });
                                    return false;
                                }
                                if (file.size > 5 * 1024 * 1024) {
                                    Toast.show({ icon: 'fail', content: '文件大小不能超过5MB！' });
                                    return false;
                                }
                                const fileCopy = new File([file], file.name, { type: file.type });
                                return fileCopy;
                            }}
                            onChange={(fileList) => {
                                console.log('OnChange - 文件列表:', fileList);
                                this.setState({ fileList });
                            }}
                            upload={async (file) => {
                                try {
                                    console.log('Upload - 开始上传:', file);

                                    // 1. 验证文件对象
                                    if (!(file instanceof File)) {
                                        throw new Error('无效的文件对象');
                                    }

                                    // 2. 创建临时预览URL
                                    const tempUrl = URL.createObjectURL(file);
                                    console.log('临时预览URL创建成功:', tempUrl);

                                    // 3. 上传文件
                                    const formData = new FormData();
                                    formData.append('file', file);
                                    formData.append('userid', this.state.userInfo.id);
                                    formData.append('scoureName', "Img");
                                    // formData.append('planetId', this.state.planetId);

                                    const response = await SaveNNFile(formData);
                                    console.log('上传响应:', response);

                                    // 4. 确保返回正确的URL格式
                                    let imageUrl;
                                    if (typeof response === 'string') {
                                        imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                    } else if (response.result) {
                                        imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                    } else {
                                        throw new Error('无效的服务器响应');
                                    }

                                    this.setState({
                                        HeadImg: response.result
                                    })
                                    // 5. 释放临时URL
                                    URL.revokeObjectURL(tempUrl);

                                    return {
                                        url: imageUrl
                                    };
                                } catch (error) {
                                    console.error('上传过程出错:', error);
                                    Toast.show({ icon: 'fail', content: '上传失败' });
                                    throw error;
                                }
                            }}
                            deleteIcon={
                                <Image src={"https://api.weibinyi.com/images/niannian/4/40-13.png"} fit='fill'
                                    width={14} height={14} />
                            }
                            children={
                                <Image src={"https://api.weibinyi.com/images/niannian/4/2-12.png"} fit='fill'
                                    width={70} height={70} />
                            }
                        /> */}
                    </div>

                    <div style={{ textAlign: "center", color: "#000", marginTop: "5px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "16px", fontWeight: "600" }}>
                            {this.state.userInfo.nickName}
                        </div>
                        <div style={{ fontSize: "17px", fontWeight: "500", color: "#000" }}>
                            {this.state.userInfo.phone}
                        </div>
                    </div>



                    <div style={{ width: "92%", backgroundColor: "#fff", marginLeft: "4%", borderRadius: "2%" }}>


                        <Form
                            name='form'
                            ref={this.formRef}
                            layout='horizontal'
                            labelCol={{ span: 8, style: { textAlign: 'right' } }} // 标签右对齐
                            wrapperCol={{ span: 16 }} // 输入框宽度
                            footer={
                                <div>
                                    <div style={{
                                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/13-09.png')",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "100% 100%",
                                        height: "38px",
                                        marginLeft: "10%",
                                        width: "80%",
                                        textAlign: "center",
                                        fontSize: "17px",
                                        lineHeight: "38px",
                                        fontWeight: "600",
                                        color: "#fff"
                                    }} onClick={this.submitForm}>
                                        提 交
                                    </div>
                                </div>
                            }
                            style={{ borderRadius: "2%" }}
                        >
                            {/* 昵称 */}
                            <Form.Item
                                name='nickName'
                                label='昵称'
                                rules={[{ required: true, message: '姓名不能为空' }]}
                            >
                                <Input
                                    onChange={console.log}
                                    placeholder='请输入姓名'
                                    style={{ textAlign: 'right', width: '100%' }} // 输入内容右对齐
                                />
                            </Form.Item>

                            {/* 性别 */}
                            <Form.Item name='sex' label='性别' rules={[{ required: true, message: '性别不能为空' }]}>
                                <Radio.Group>
                                    <Space direction='horizontal'>
                                        <Radio value={false}>男</Radio>
                                        <Radio value={true}>女</Radio>
                                    </Space>
                                </Radio.Group>
                            </Form.Item>

                            {/* 手机号 */}
                            <Form.Item rules={[{ required: true, message: '手机号不能为空' }]}
                                name='phone'
                                label='手机号'
                            >
                                <Input
                                    onClick={() => this.setState({
                                        visible: 'demo1'
                                    })} // 点击时显示数字键盘
                                    onChange={(value) => {
                                        if (value.length > 11) {
                                            Toast.show({ content: '手机号最多11位数！' });
                                            return;
                                        }
                                        this.setState({ phoneNumber: value });
                                    }}
                                    placeholder='请输入手机号'
                                    style={{ textAlign: 'right', width: '100%' }} // 输入内容右对齐
                                    onFocus={(e) => e.target.blur()}
                                />
                            </Form.Item>

                            {this.state.visible === 'demo1' && (
                                <Mask
                                    visible={true}
                                    onMaskClick={() => this.setState({ visible: '' })} // 点击遮罩层时隐藏键盘
                                    color='white'
                                >
                                    <div
                                        style={{
                                            position: 'fixed',
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            zIndex: 1000,
                                        }}
                                    >
                                        <NumberKeyboard
                                            visible={true} // 始终显示键盘
                                            onClose={actions.onClose}
                                            onInput={actions.onInput}
                                            onDelete={actions.onDelete}
                                        />
                                    </div>
                                </Mask>
                            )}

                            {/* 个性签名 */}
                            <Form.Item
                                name='signature'
                                label='个性签名'
                            >
                                <Input
                                    onChange={console.log}
                                    placeholder='请输入个性签名'
                                    style={{ textAlign: 'right', width: '100%' }} // 输入内容右对齐
                                />
                            </Form.Item>
                        </Form>


                    </div>

                </div>



                <BottomMenu position="fixed" selectKey="my" />

            </div>
        )
    }
}

export default withNavigate(Index);